import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-win",
  "use": "icon-win-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-win\"><path d=\"M523.808 191.392v288.896h381.984V128.096L523.84 191.36z m0 642.208l381.984 62.208v-352H523.84v289.792zM120.096 480.192h322.88V201.92L120.128 255.392v224.8z m0 290.4l322.88 52.608v-279.392H120.128v226.784z\" fill=\"#5C677C\" p-id=\"7004\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol